import { useEffect, useState } from "react";
import { Toggle } from "rsuite";
import { StorageAuth } from "../../core/localStorage/StorageAuth";
import { AppUserRoles } from "../../config/constants";

type Props = {
  readOnly?: boolean;
  value?: Record<string, any>;
  onChange: (formValue: Record<string, any>) => void;
  onCheck: React.Dispatch<React.SetStateAction<{}>>;
};

export function TaskListForm(props: Props): JSX.Element {
  const [displayName, setDisplayName] = useState(
    props.value?.displayName || ""
  );
  const [name, setName] = useState(props.value?.name || "");
  const [procedureCode, setProcedureCode] = useState(props.value?.procedureCode || "");
  const [isDefaultForDHHS, setIsDefaultForDHHS] = useState(
    !!props.value?.isDefaultForDHHS
  );
  const [isDefault, setIsDefault] = useState(!!props.value?.isDefault);
  const [precedence, setPrecedence] = useState(props.value?.precedence || 0);
  const isSuperAdmin = StorageAuth.Role === AppUserRoles.SuperAdmin;

  useEffect(() => {
    setDisplayName(props.value?.displayName ?? displayName);
    setName(props.value?.name ?? name);
    setProcedureCode(props.value?.procedureCode ?? procedureCode);
    setIsDefaultForDHHS(props.value?.isDefaultForDHHS ?? isDefaultForDHHS);
    setIsDefault(props.value?.isDefault ?? isDefault);
    setPrecedence(props.value?.precedence ?? precedence);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.value?.displayName,
    props.value?.name,
    props.value?.procedureCode,
    props.value?.isDefaultForDHHS,
    props.value?.isDefault,
    props.value?.precedence,
  ]);

  return (
    <form className="row">
      <div className="col-md-6 col-12 px-2 mb-2">
        <label>
          Patient Task Name :<span className="text-red-300">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          required
          value={name}
          name="name"
          onChange={(e) => {
            setName(e.target.value);
            setDisplayName(e.target.value);
            props.onChange({
              name: e.target.value,
              displayName: e.target.value,
              procedureCode,
              isDefaultForDHHS,
              isDefault,
              precedence,
            });
          }}
        />
      </div>

      <div className="col-md-6 col-12 px-2">
        <label>
          Task Display Name :<span className="text-red-300">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          required
          value={displayName}
          name="displayName"
          onChange={(e) => {
            setDisplayName(e.target.value);
            props.onChange({
              name,
              displayName: e.target.value,
              procedureCode,
              isDefaultForDHHS,
              isDefault,
              precedence,
            });
          }}
        />
      </div>

      <div className="col-md-6 col-12 px-2">
        <label>
          Procedure Code :
        </label>
        <input
          className="form-control"
          type="text"
          value={procedureCode}
          name="procedureCode"
          onChange={(e) => {
            setProcedureCode(e.target.value);
            props.onChange({
              name,
              displayName,
              procedureCode: e.target.value,
              isDefaultForDHHS,
              isDefault,
              precedence,
            });
          }}
        />
      </div>

      <div className="col-md-6 col-12 px-2">
        <label>
          Precedence :
        </label>
        <input
          className="form-control"
          type="number"
          value={precedence}
          name="precedence"
          onChange={(e) => {
            setPrecedence(e.target.value);
            props.onChange({
              name,
              displayName,
              procedureCode,
              isDefaultForDHHS,
              isDefault,
              precedence: e.target.value,
            });
          }}
        />
      </div>

      {isSuperAdmin && (
        <>
          <div className="col-md-6 col-12 px-2 mt-2">
            <label>Is Default?</label>
            <Toggle
              checked={isDefault}
              className="ms-2"
              size="xs"
              onChange={(e) => {
                setIsDefault(e);
                props.onChange({ 
                  name, 
                  displayName, 
                  procedureCode, 
                  isDefaultForDHHS,
                  isDefault: e,
                  precedence 
                });
              }}
            />
          </div>
          <div className="col-md-6 col-12 px-2 mt-2">
            <label>Is default for DHS?</label>
            <Toggle
              checked={isDefaultForDHHS}
              className="ms-2"
              size="xs"
              onChange={(e) => {
                setIsDefaultForDHHS(e);
                props.onChange({ 
                  name, 
                  displayName, 
                  procedureCode, 
                  isDefaultForDHHS: e,
                  isDefault,
                  precedence 
                });
              }}
            />
          </div>
        </>
      )}
    </form>
  );
}
